<template>
    <div class="container-fluid">
        <div v-if="formId" class="row formium-builder flex-nowrap"> <!-- FORM BUILDER ROW -->
            
            <div class="col-auto min-width-300">
                <div style="position: sticky; top: 0;">
                    <h4 class="text-muted mb-1">Question Types</h4>
                    <p class="small mb-2 text-muted">Drag & drop questions from here to your form.</p>
                    <draggable
                        tag="div"
                        :list="itemtypesAvailableToAdd"
                        class="dragarea itemtypes w-100"
                        :class="isLocked ? 'opacity-60' : ''"
                        :group="{ name: 'form', pull: 'clone', put: false, revertClone: true }"
                        :clone="cloneField"
                        :sort="false"
                        :disabled="isLocked"
                    >
                        <div 
                            v-for="itemtype in itemtypesAvailableToAdd" 
                            :key="itemtype.id"
                            class="itemtype d-flex d-item"
                            style="position: relative;"
                        >
                            <div class="left-side d-flex justify-content-center align-items-center">
                                <b-icon :icon="itemtype.iconName" variant="primary" scale="1.5"></b-icon>
                            </div>
                            <div class="right-side d-flex justify-content-start align-items-center">
                                {{itemtype.text}}
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>

            <div class="col-auto flex-fill">

                <div>
                    <h4 class="text-muted mb-1">Response Form Preview</h4>
                    <p class="small mb-2 text-muted">Drag question types onto this area.  Click on a question to edit the details.</p>
                </div>

                <div v-if="loadingForm" class="w-100 d-flex flex-column justify-content-center align-items-center p-3" style="min-height: 200px;">
                    <b-spinner class="d-block" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
                    <span class="h5 d-block text-uppercase text-muted mt-4">Loading Response Form...</span>
                </div>

                <div v-else>
                    <div
                        class="title-area mb-3 d-flex"
                        :class="[ (selectedIndex === 'title') ? 'selected-item' : '' , isLocked ? 'opacity-60' : '']"
                        @click="handleTitleClick"
                    >
                        <div class="left-side d-flex flex-column align-items-start">
                            <span class="font-weight-bold text-muted" style="font-size: 1.3rem;">Title</span>
                            <b-icon v-if="!titleValid" icon="exclamation-circle" class="icon-invalid" variant="danger" aria-hidden="true"></b-icon>
                        </div>
                        <div class="right-side">
                            <h3 :class="formData.title ? '' : 'text-muted'">{{ formData.title ? formData.title : '[Form Title]' }}</h3>
                            <p class="mb-0" :class="formData.instructions ? '' : 'text-muted'">{{ this.formData.instructions ? this.formData.instructions : this.formInstructionsPlaceholder }}</p>
                        </div>
                    </div>

                    <div v-if="formitems.length < 1" class="my-2 text-muted text-center text-uppercase font-weight-bold">
                        Drag & Drop questions to the area below
                    </div>

                    <draggable
                        :list="formitems"
                        group="form"
                        handle=".formium-item-handle"
                        draggable=".d-item"
                        animation="300"
                        class="dragarea formitems w-100"
                        :class="[(formitems.length < 1) ? 'empty-list' : '', isLocked ? 'opacity-60' : '' ]"
                        :disabled="isLocked"
                        @choose="handleChoose"
                        @start="handleStart"
                        @end="handleEnd"
                        @change="handleChangeMain"
                        @add="handleAdd"
                    >
                        <!-- do not add transition group here - causes problems dragging one list to another and transition animations look fine without -->
                            <formium-form-builder-item 
                                v-for="(formitem, index) in formitems" 
                                :key="formitem.uuid" 
                                :value="formitem" 
                                :list-index="index" 
                                :is-selected="index === selectedIndex" 
                                class="formium-item d-item"
                                :class="[ (index === selectedIndex) ? 'selected-item' : '' ]"
                            >
                            </formium-form-builder-item>  <!-- removed delete button from this, only showing in editor for now -->
                
                    </draggable>

                    <div 
                        v-if="formitems.length === 0"
                        id="formbuilder-drag-suggest" 
                        class="mt-4 text-black-50 d-flex align-items-end"
                        style="padding-top: 50px; padding-left: 50px;"
                    >
                        <!-- <b-icon icon="arrow-left" font-scale="2" class="mr-3 text-muted opacity-50"></b-icon> -->
                        <div class="">
                            <!-- <b-icon icon="arrow-up" font-scale="2" class="text-muted opacity-50"></b-icon> -->
                            <div class="mt-3 d-flex align-items-center">
                                <b-icon icon="arrows-move" font-scale="2"></b-icon>
                                <div class="ml-2">Drag questions<br>onto the form</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col min-width-400 max-width-400 d-flex flex-column justify-content-between">
                <div style="position: sticky; top: 0;">

                    <div class="d-flex mb-3 ">
                        <div class="d-block w-65" style="height: 40px;">
                            <transition name="fade-fast" appear mode="out-in">
                                <div v-if="saveSuccessShow" key="message" class="d-flex w-100 h-100 justify-content-center align-items-center">
                                    <div class="text-success font-weight-bold font-size-100 text-uppercase">
                                        Saved
                                        <i class="fas fa-check-circle ml-2"></i>
                                    </div>
                                </div>
                                <b-button v-else key="button" :variant="unsavedChanges ? 'soft-primary' : 'soft-secondary'" block class="mb-4 h-100" :disabled="!overallValid || saveLoading || !unsavedChanges" @click="saveFormData">
                                    <transition name="fade-fast" mode="out-in">
                                        <span v-if="saveButtonState === 'loading'" key="loading" class="d-flex justify-content-center align-items-center">
                                            <b-spinner small type="grow" class="mr-3"></b-spinner>
                                            <span>Loading...</span>
                                        </span>
                                        <span v-else-if="saveButtonState === 'unsaved'" key="unsaved" class="d-flex justify-content-center align-items-center">
                                            <i class="fas fa-save mr-2"></i>
                                            <span>Save Changes</span>
                                        </span>
                                        <span v-else key="saved">
                                            All Changes Saved
                                        </span>
                                    </transition>
                                </b-button>
                            </transition>
                        </div>
                        <div class="w-35 pl-2">
                            <b-button variant="sharp-secondary" block class="h-100" @click="handleDone">
                                Done
                            </b-button>
                        </div>
                    </div>

                    <!-- <div v-if="!overallValid && !hasItemSelection && !loadingForm" class="text-danger mb-3">
                        <b-icon icon="exclamation-circle" variant="danger" class="icon-invalid" aria-hidden="true"></b-icon>
                        <span class="ml-2">Please fix items with errors.</span>
                    </div> -->

                    <div v-if="error" class="text-danger my-3">{{ errorMsg }}</div>
                    

                    <b-alert v-if="isLocked" variant="warning" show>
                        <h5>
                            <b-icon icon="lock-fill" class="mr-1"></b-icon>
                            Form is locked for edits
                        </h5>
                        <p class="small">Suppliers have already submitted responses to this form, or you do not have edit permissions.  If you make changes (if allowed), you should notify suppliers by sending a bulk message, or by notifying them individually.  Then when they login, the system will highlight any missing questions they must complete.</p>
                        <b-button :disabled="readOnly" @click="toggleIsLocked" variant="warning">
                            <b-icon icon="unlock-fill" class="mr-1"></b-icon>
                            OK, unlock & edit
                        </b-button>
                    </b-alert>

                    <b-card v-else class="item-editor" :class="(hasItemSelection || formSettingsSelected) ? 'selected' : '' ">
                        <!--
                        <template v-slot:header>
                            <h5 class="mb-0">
                                Edit Item
                            </h5>
                        </template>
                        -->

                        <transition name="fade-fast" mode="out-in">
                            <div v-if="formSettingsSelected" key="title" class="item-editor-form">
                                <p class="text-secondary text-uppercase font-weight-bold">Edit Form:</p>
                                <b-form-group
                                    id="fieldset-title"
                                    label="Form Title"
                                    label-for="input-title"
                                    invalid-feedback="Required"
                                    :state="titleValid"
                                >
                                    <b-form-input autofocus required :state="titleValid" id="input-title" trim v-model="formData.title"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    id="fieldset-instructions"
                                    label-for="input-instructions"
                                >
                                    <template v-slot:label>
                                        Form Instructions
                                        <span class="small text-muted ml-2">Optional</span>
                                    </template>
                                    <b-form-textarea id="input-instructions" trim rows="4" v-model="formData.instructions"></b-form-textarea>
                                </b-form-group>
                                <b-button @click="resetSelected" class="w-50" variant="secondary">Done Editing</b-button>
                            </div>
                            
                            <div v-else-if="hasItemSelection" :key="selectedIndex" class="item-editor-form">
                                <formium-field-editor 
                                    v-model="formitems[selectedIndex]"
                                    @done-edit="handleDoneEdit" 
                                    @remove-item-by-uuid="handleRemoveItemByUuid"
                                >
                                </formium-field-editor>
                            </div>

                            <div v-else key="noedit" class="item-editor-form">
                                <div v-if="!overallValid && !loadingForm" class="text-danger mb-3">
                                    <b-icon icon="exclamation-circle" variant="danger" class="icon-invalid" aria-hidden="true"></b-icon>
                                    <span class="ml-2">Please fix items with errors.</span>
                                </div>
                                <b-icon icon="arrow-left" variant="primary" scale="2" aria-hidden="true"></b-icon>
                                <span class="ml-2">Click on an item to edit</span>
                            </div>

                        </transition>
                    </b-card>
                </div>

                <div class="mt-4 text-right">
                    <instructions-modal
                        modal-title="Form Builder Instructions"
                    >
                        <ul class="list-flush list-margin-2">
                            <li>Drag and drop questions from the Question Types to the Form Preview area.</li>
                            <li>Click on any question to edit the details.</li>
                            <li>Make a question required / optional using the "Required?" option when editing details.</li>
                            <li>Adjust the order of the questions by dragging them to the desired position.</li>
                            <li>Any questions with missing information will be shown with a red warning.  Fix those before saving.</li>
                            <li>Edit the form title and instructions by clicking on the Form Title box.</li>
                            <li>Click "Save Changes" when ready, then click "Done" to close the Form Builder.</li>
                        </ul>
                    </instructions-modal>
                </div>
            
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { itemTypes, allItemTypes } from '../../js/formium-helpers';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import { suppliosApi } from '../../js/api-service';
import FormiumFieldEditor from './FormiumFieldEditor';
import FormiumFormBuilderItem from './FormiumFormBuilderItem';
import { v4 as uuidv4 } from 'uuid';  // use it like uuidv4()
import { tenantInfoMixin } from '../../js/custom-vue-mixins';

// NEW FORM ITEM CONSTRUCTOR - using named parameters / object destructuring - last line of arg = {} is the default if you just did new FormItem()
// you can now create new FormItem objects by passing in an object with named args like this:  let newItem = new FormItem({label: 'My Label'})
function FormItem({
    // assign default values here
    pk = null,
    label = '', 
    uuid = uuidv4(),
    required = true,
    help_text = '',
    choices = '',
    field_type_slug = '', 
    parent_form = '',
    position = null, 
    currency = '',
} = {}) {
    // set all the things from your args object
    this.pk = pk;
    this.label = label;
    this.uuid = uuid;
    this.required = required;
    this.help_text = help_text;
    this.choices = choices;
    this.type = field_type_slug;
    this.parent_form = parent_form;
    this.position = position;
    this.currency = currency;  // only used for money fields
    // set some extra things
    this.id = this.pk;
    this.isValid = false;
    this.itemType = itemTypes.find(t => t.value === this.type);  // put the full itemType object in here for reference
    this.getChoicesArray = function() {
        return this.choices.split(",").map((choice)=>choice.trim()).filter(ch => !!ch);  // that last bit removes any empty choices
    };
    // validity stuff
    this.choicesValid = function() {
        if (!this.itemType.hasChoices) return true;  // if this itemType doesn't have choices, then return true
        // if we DO have choices...  choices will be a string of comma separated values
        let choicesArray = this.getChoicesArray();
        const minChoicesQty = 2;
        let choicesLengthOk = !!choicesArray && Array.isArray(choicesArray) && (choicesArray.length >= minChoicesQty);
        return choicesLengthOk;
    };
    this.labelValid = function() {
        return !!this.label;
    };
    this.isItemValid = function() {
        // you have to CALL this... can't just check it, its not a computed property... but you COULD make it a getter... get isItemValid() {...}
        this.isValid = this.labelValid() && this.choicesValid();
        return this.isValid;  // set isValid while you're at it
    };
    this.apiFormat = function(newArrayIndex) {
        return {
            id: this.id,
            label: this.label,
            uuid: this.uuid,
            required: this.required,
            help_text: this.help_text,
            choices: this.choices,
            field_type: this.itemType.typeClass,
            is_active: true,
            parent_form: this.parent_form,
            position: newArrayIndex + 1, // this.position, 
            currency: this.currency
        };
    };
}

export default {
    name: 'FormiumFormBuilder',
    components: {
        draggable,
        FormiumFieldEditor,
        FormiumFormBuilderItem,
    },
    mixins: [
        tenantInfoMixin,
    ],
    props: {
        formId: {
            type: [String, Number],
            required: true,
        },
        readOnly: {  // NOTE - there is something in data called 'isLocked' (based on API data) but setting this prop true will also set that
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingForm: false,
            saveLoading: false,
            saveSuccessShow: false,
            unsavedChanges: false,  // a boolean to track if there are un-saved changes
            itemtypes: allItemTypes,  // the list of possible form fields, filtered from canonical master list (above) of field definitions
            formitems: [],   // the array you are manipulating, set during getFormData()
            selectedIndex: null,
            dragging: false,  // set to true when dragging draggable items, used to control transition-group animations
            formData: {  // stash both title and instructions in here so its easier to watch both of them
                title: '',
                instructions: '',
            },  
            formInstructionsPlaceholder: '[Your form instructions will go here.  Use this to provide helpful information to the person filling out the form.]',
            // NEW STUFF
            overallValid: false, // update this from a method whenever you check all the items
            lastSavedData: {},  // stash last saved data here for unsaved comparison
            isLocked: false,  // is it locked from edits because of has_submitted_replies ?  Can override by calling toggleIsLocked() method
        }
    },
    computed: {
        itemtypesAvailableToAdd() {
            // the ones that are available in the drag-from area
            return this.itemtypes.filter(t => t.showInList === true);
        },
        invalidItemIds: function() {
            return this.formitems.filter(item => item.isValid === false).map(inv => inv.id);
        },
        titleValid: function() {
            return this.formData.title ? true : false;
        },
        hasItemSelection: function() {
            return this.selectedIndex !== null && this.selectedIndex !== 'title';  
            // need to specifically check !== null for selectedIndex... can't just check boolean like !! -- otherwise index of 0 returns false
        },
        formSettingsSelected: function() {
            return this.selectedIndex === 'title';
        },
        saveButtonState: function() {
            // there are 3 possible states for Save button: "loading", "unsaved", and "saved"
            if (this.saveLoading || this.loadingForm) return 'loading';
            if (this.unsavedChanges) return 'unsaved';
            return 'saved';
        },
    },
    watch: {
        formData: {
            deep: true,
            handler: function() {
                this.checkEverything();
            },
        },
    },
    mounted: function () {
        //this.loadingForm = true;
        this.getFormData();
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        setDataFromApi: function(respData) {
            // added Nov 24 2020 - set local data after fetching from API and after saving
            //this.initialFormData = Object.assign({}, respData);
            this.formData.title = respData.title;
            this.formData.instructions = respData.instructions;
            this.formitems = respData.active_items.map(item => {
                //return new FormItem(item.pk, item.label, item.uuid, item.required, item.help_text, item.choices, item.field_type_slug, item.parent_form, item.position, item.currency)
                return new FormItem(item);  // pass in the full item object, your FormItem constructor uses object destructuring
                // do you want to do any sorting by position?  backend SHOULD return them ordered by position, but maybe you should check since it really matters here
            });
            this.lastSavedData = this.formatDataForApi();  // this.formatDataForApi() does a clone before returning it
            this.isLocked = this.readOnly || (respData.has_submitted_replies === true) ? true : false;  // should we lock it from being modified?  If locked, we'll show an override switch which sets isLocked = false
            this.checkEverything();
        },
        getFormData: function() {
            this.loadingForm = true;
            return suppliosApi.formiumForm.retrieve(this.formId)
                .then(response => {
                    this.setDataFromApi(response.data);
                    return true;
                })
                .catch(error => {
                    this.handleError(error, 'Error while getting form data');
                    return false;
                })
                .then(success => {
                    this.loadingForm = false;
                    return success;
                });
        },
        formatDataForApi: function() {
            // added Nov 24 2020
            let saveData = {};
            saveData['title'] = this.formData.title;
            saveData['instructions'] = this.formData.instructions;
            saveData['formium_items'] = this.formitems.map((item, index) => item.apiFormat(index));  // do you need to clone this?  just clone it once before returning it... should be good
            return cloneDeep(saveData);
        },
        saveFormData: function() {
            // NOTE - YOU ARE USING ENDPOINT FROM RFXFORM VIEWSET (not @ACTION ON RFX VIEWSET)  PLAN ACCORDINGLY...
            this.saveLoading = true;
            let saveData = this.formatDataForApi();
            return suppliosApi.formiumForm.update(this.formId, saveData)
                .then(response => {
                    this.setDataFromApi(response.data);
                    this.saveSuccess();
                    return true;
                })
                .catch(error => {
                    this.handleError(error, 'Error while saving form');
                    return false;
                })
                .then(saveSuccess => {
                    this.saveLoading = false;
                    return saveSuccess;
                })
        },
        checkEverything: function() {
            // check all item validity and set overallValid, check for changes
            console.log("Here is the array of this.formitems");
            console.log(this.formitems);
            let formItemsValid = this.formitems.every(fitem => fitem.isItemValid());
            this.overallValid = formItemsValid && this.titleValid;
            this.unsavedChanges = !isEqual(this.formatDataForApi(), this.lastSavedData);
        },
        saveSuccess: function() {
            this.saveSuccessShow = true;
            setTimeout( () => {this.saveSuccessShow = false}, 2000);
        },
        toggleIsLocked: function() {
            // if isLocked = true (ie: already has_submitted_replies = true) we will show a switch to override, which calls this to unlock
            // Nov 9 2022 - but if prop readOnly is true, then we block this too
            if (this.readOnly) {
                return;
            }
            this.isLocked = !this.isLocked;
        },
        handleStart: function() {
            console.log('from handleStart');
            this.dragging = true;
        },
        handleEnd: function(endEvent) {
            console.log('from handleEnd');
            this.dragging = false;
            this.selectedIndex = endEvent.newIndex;
        },
        /* handleRemoveItem: function(position) {  // replaced by UUID version 
            // called from the form editor
            this.resetSelected();
            this.formitems.splice(position, 1);
            this.checkEverything();
        }, */
        handleRemoveItemByUuid: function(itemUuid) {
            // the uuid of the form item is passed in
            console.log(`from handleRemoveItemByUuid, we will remove uuid ${itemUuid}`);
            this.resetSelected();  // I *think* I have to do this first
            let itemIndex = this.formitems.findIndex(item => item.uuid === itemUuid);
            console.log(`found item at index ${itemIndex}`);
            if (itemIndex !== -1) {
                this.formitems.splice(itemIndex, 1);
            }
            this.checkEverything(); // I *think* I have to do this after removing item
        },
        handleChoose: function(chooseEvent) {
            // console.log("CHOOSE # " + chooseEvent.oldIndex);
            // CAREFUL -- if you use header (or footer) slots those will be included in the index.
            // So subtract 1 to get the real index if header slot is used.
            console.log('from handleChoose - chooseEvent below');
            console.log(chooseEvent);
            this.selectedIndex = chooseEvent.oldIndex;
        },
        resetSelected: function() {
            // console.log("hello from resetSelected");
            this.selectedIndex = null;
        },
        handleDoneEdit: function() {
            // called by FormiumFieldEditor when clicked on 'Done Editing' button
            this.resetSelected();
            this.checkEverything();
        },
        handleAdd: function(addEvent) {
            // used to change selection when you drop something into the form, that isn't handled in clone
            this.selectedIndex = addEvent.newIndex;
        },
        cloneField: function(cloneObject) {
            // method called when cloning a field when dropping it onto the form area
            // Function called ON THE SOURCE COMPONENT to clone element when clone option is true. 
            // should return the new object that you want on the new list (form)
            // MAKE SURE YOU DO THIS THE SAME WAY YOU CREATE OBJECTS WHEN FETCHING FROM API (ie: use same object constructor function)
            let newItemArgs = {
                // only need to declare things here that you want to be different from defaults in FormItem object constructor
                required: true,  // should you make all new fields required by default?
                field_type_slug: cloneObject.value,
                parent_form: this.formId,
            };
            return new FormItem(newItemArgs);
        },
        updatePositions: function() {
            // update all the item positions... call this when array changes
            // just go through all items in the array and set item.position to its index + 1
            // .forEach callback takes 3 args:  currentValue, index, array -- you just need currentValue (FormItem) and index
            this.formitems.forEach((item, index) => {
                item.position = index + 1;
                //console.log(`Going to set ${item.label} to ${index + 1}`);
            });
        },
        handleChangeMain: function(draggableEvent) {
            // draggable event gets passed into this... can use it if needed
            // called on the @change event for the MAIN draggable element
            console.log("Here is the event from handleChangeMain");
            console.log(draggableEvent);
            // this.updatePositions();  // NEW - we'll display positions based on current draggable index, then set item.position when we format for api
            this.checkEverything();  // call method that checks validity, changes, etc.
        },
        handleTitleClick: function() {
            this.selectedIndex = 'title';
        },
        emitCloseMe: function() {
            // emit 'close-me' event to parent to request being closed
            this.$emit('close-me');
        },
        handleDone: function() {
            if (!this.unsavedChanges) {
                this.emitCloseMe();  // if no unsaved changes, just close
                return;
            }
            let saveChangesPromise = this.$bvModal.msgBoxConfirm('There are unsaved changes.  Save before closing?', {
                title: 'Save Changes?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Save Changes',
                cancelVariant: 'danger',
                cancelTitle: 'Discard Changes',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
              })
                .then(value => {  // value = true means OK clicked (save changes);  value = false means discard changes
                    return value;  
                })
                .catch(err => {
                    console.log('Error from confirm message box');
                    console.log(err);
                    return null;  // return null, same as if message box was closed without user making a choice
                })
                .then(saveChanges => {
                    return saveChanges;  // saveChanges should be a boolean returned from modal message box (from then or catch above)
                    // true = user clicked OK to save changes
                    // false = user wants to discard changes
                    // null = user closed message modal without choosing, so don't save or discard
                });
            // now deal with result of message box confirm
            saveChangesPromise.then(saveChanges => {
                // saveChanges = null means modal was closed, so check for true and false explicitly
                if (saveChanges === false) {  // if user clicked to discard changes
                    this.emitCloseMe();
                    return 'discard-changes';  // just return something...
                }
                if (saveChanges === true) {  // if user clicked to save changes, save changes then close, or don't close if not successful
                    if (!this.overallValid) {
                        // handle case where we want to save changes, but has errors
                        return this.handleErrorsOnSave().then(errorsOnSaveDecision => {
                                if (errorsOnSaveDecision === 'fix-errors') {
                                    return 'fix-errors';
                                }
                                if (errorsOnSaveDecision === 'discard-changes') {
                                    this.emitCloseMe();
                                    return 'discard-changes';
                                }
                            });
                    } 
                    // handle case where we want to save changes, but no errors -- save the Data then close
                    return this.saveFormData().then(saveSuccess => {
                            if (saveSuccess) {  // if save was successful, then we can now close 
                                this.emitCloseMe();
                                return 'saved-changes';  // just return something from the nested then()
                            }
                            // if save was not successful we'll be here, don't close form builder, but return something to get out of confirm message box
                            return 'not-saved';  // returning from nested then()
                        });
                }
                // handle null case, where saveChanges = null -- don't save changes and don't close modal -- do nothing
                return 'do-nothing';
            })
        },
        handleErrorsOnSave: function() {
            // show confirmation modal if trying to save with errors (might be triggered from other confirm modal trying to save on Done)
            return this.$bvModal.msgBoxConfirm('There are errors or incomplete information.  Do you want to fix them?  Or discard all changes?', {
                title: 'Fix Errors?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Fix Errors',
                cancelVariant: 'danger',
                cancelTitle: 'Discard Changes',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {  // value = true means OK clicked (save changes);  value = false means discard changes
                if (value) {
                    // if value is true, then user clicked on OK, wants to fix errors, -- return something accordingly
                    return 'fix-errors';
                } else {
                    // if not true, then discard changes,
                    return 'discard-changes'; 
                }
            });
        },
    }
}
</script>

<style lang="scss">

// this is messy because you copied it from previous .css file - should be / can be cleaned up
// but better than having it be a separate css file far away....
// you could make use of variables to set things that you want in multiple places here

.formium-builder {

    .form-group > label,
    .formium-item fieldset > legend {
        font-weight: 600;
        font-size: 1rem;
        color: #000;
        margin-bottom: 4px;
    }

    fieldset {
        small:focus {outline: none;}
    }

    .formium-item {
        fieldset {
            margin-bottom: 0;
            input,
            textarea, 
            .b-form-datepicker button, 
            .b-form-datepicker label,
            input.form-control::placeholder,
            textarea.form-control::placeholder {
                color: #888;
                font-weight: 300;
                cursor: move;
            }
        }
    }

    .dragarea.formitems,
    .dragarea.itemtypes,
    .title-area {
        min-height: 100px;
        background-color: var(--primary);
        border: 1px solid #ddd;
        box-shadow: 0 1px 4px rgb(207, 207, 207);
    }
    
    .dragarea.formitems.empty-list {
        background-color: var(--light2);
        border: 3px dashed var(--info);
        min-height: 100px;
        border-radius: 0.5rem;
        color: #aaa;
        font-size: 1.5rem;
        font-weight: 700;
        text-transform: uppercase;
        text-align: center;
    }

    .formium-item,
    .itemtype,
    .title-area {
        background-color: #fff;
        border-color: #eee;
        border-style: solid;
        border-left-style: none;
        border-width: 1px;
        border-radius: 0;
        overflow: hidden;
        position: relative;
        margin-bottom: 0;
        /*box-shadow: 0 1px 4px rgb(226, 226, 226);*/
        cursor: move;
        /* should leave these out otherwise they mess up the list ordering transitions
        transition: 0.1s transform;
        transition-timing-function: ease;
        */
    }

    .formium-item .left-side,
    .title-area .left-side {
        width: 10%;
        min-width: 70px;
        border-color: #ddd;
        border-style: solid;
        border-width: 0 0 0 5px;
        padding: 0.5rem;
        background-color: var(--light2);
    }
    .formium-item .right-side,
    .title-area .right-side {
        padding: 1.25rem 1rem;
    }
    .formium-item {
        input,
        textarea,
        .b-form-file label.custom-file-label {
            background-color: #fff !important;
            /* this is to make sure disabled inputs look normal */
        }
    }
    .selected-item {
        /*transform: translateX(8px);*/
        transform: scale(1.01);
        z-index: 10;
        border-radius: 0.25rem;
    }
    .selected-item,
    .selected-item .left-side {
        border-left-color: var(--primary);
    }
    .sortable-drag,
    .sortable-chosen,
    .selected-item {
        box-shadow: 0 2px 10px rgb(170, 170, 170);
    }
    .selected-item, 
    .selected-item .left-side,
    .item-editor.selected .card-body {
        background-color: #f5f5f5 !important;
    }

    .item-editor {
        border-radius: 0.5rem;
        border: 1px solid #ddd;
        /*box-shadow: 0 1px 4px rgb(207, 207, 207);*/
        overflow: hidden;
        transition: 0.1s box-shadow;
        &.selected {
            box-shadow: 0 2px 10px rgb(170, 170, 170);
        }
        .card-header {
            background-color: var(--light2);
        }
    }

    .itemtype {
        min-height: 45px;
        .left-side {
            width: 20%;
            min-width: 50px;
            border-color: #ddd;
            border-style: solid;
            border-width: 0 0 0 4px;
            padding: 0.25rem;
            background-color: var(--light2);
        }
        .right-side {
            padding: 0.25rem;
            padding-left: 0.5rem;
            text-transform: uppercase;
            font-size: 0.8rem;
            font-weight: 600;
        }
    }

    .sortable-drag,
    .sortable-drag .left-side,
    .sortable-chosen,
    .sortable-chosen .left-side {
        cursor: move;
        border-color: var(--primary);
    }
    .sortable-drag .hide-during-drag,
    .sortable-ghost .hide-during-drag {
        display: none;
    }
    .dragarea .sortable-ghost {
        opacity: 0.7;
        background: #fff;
        border: 3px solid var(--primary) !important;
    }
    .dragarea.itemtypes .sortable-ghost {
        opacity: 0.2;
        background: #fff;
    }
    .icon-invalid {
        font-size: 1.2rem;
    }

}

#formbuilder-drag-suggest {
    animation-name: drag-suggest;
    animation-duration: 5s;
    animation-iteration-count: 3;
    animation-direction: normal;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
    animation-delay: 0;
}

$drag-animation-x: -150px;
$drag-animation-y: -150px;

@keyframes drag-suggest {
    0% {
        transform: translate($drag-animation-x, 0);  // start fade in
        opacity: 0;
    }
    15% {
        transform: translate($drag-animation-x, 0);  // finish fade in
        opacity: 1;
    }
    25% {
        transform: translate($drag-animation-x, 0);  // start move
        opacity: 1;
    }
    65% {
        transform: translate(0, $drag-animation-y);  // finish move
        opacity: 1;
    }
    75% {
        transform: translate(0, $drag-animation-y);  // start fade out
        opacity: 1;
    }
    90% {
        transform: translate(0, $drag-animation-y);  // finish fade out
    }
    100% {
        transform: translate($drag-animation-x, 0);  // hidden time, start over
        opacity: 0;
    }
}

</style>
